export function SampleOutput() {
  return (
    <section className="bg-white border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-10">
          <h2
            className="text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            Here's What You'll Receive
          </h2>
          <p className="text-zinc-600 mt-2">A real example from a recent delivery</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-zinc-50 border border-zinc-200 p-6 mb-4">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-bold text-zinc-900">Product Manager - Remote (SaaS)</h3>
                <p className="text-sm text-zinc-600">TechStartup Inc. - San Francisco / Remote</p>
              </div>
              <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">95% Match</span>
            </div>
            <div className="bg-white border border-zinc-200 p-3 rounded mb-3">
              <p className="text-xs text-zinc-500 uppercase font-medium mb-1">Why this fits you:</p>
              <p className="text-sm text-zinc-700">
                Matches your 3+ years SaaS experience. They're looking for someone with your exact background in B2B products.
              </p>
            </div>
            <div className="flex items-center gap-4 text-sm">
              <span className="text-[#002FA7] font-medium">Apply Link Included</span>
              <span className="text-zinc-500">+ Cover Letter</span>
              <span className="text-zinc-500">+ Email Template</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-zinc-500 text-sm">
            <span>+ 19-49 more jobs like this</span>
          </div>
        </div>
      </div>
    </section>
  );
}
